// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JmP-","col":"styles_col__1hRUA"};